import "./__thumbnail__parent_page.scss"; import "./__thumbnail.scss"

